module.exports = __webpack_public_path__ + "img/alipay_logo.858009da.jpg";